import { server, port } from "./environment";

const URL = `${server}:${port}`;

const zonaService = {
  async getZonas() {
    const response = await fetch(`${URL}/api/zonas/`);
    return response.json();
  },

  async createZona(zona) {
    const response = await fetch(`${URL}/api/zonas/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(zona),
    });
    return response.json();
  },

  async updateZona(zona) {
    const response = await fetch(`${URL}/api/zonas/`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(zona),
    });
    return response.json();
  },

  async deleteZona(id) {
    const response = await fetch(`${URL}/api/zonas/${id}`, {
      method: 'DELETE',
    });
    return response.json();
  },

  async importZonas(zonas) {
    const response = await fetch(`${URL}/api/zonas/import`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(zonas),
    });
    return response.json();
  },
};

export default zonaService;
